import type { SVGProps } from 'react';
const SvgLeaderboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#leaderboard_svg__a)">
      <path
        fill="currentColor"
        d="M7.5 21H2V9h5.5v12Zm7.25-18h-5.5v18h5.5V3ZM22 11h-5.5v10H22V11Z"
      />
    </g>
    <defs>
      <clipPath id="leaderboard_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLeaderboard;
